module.exports = __webpack_public_path__ + "static/img/subcontract3.10966e50.png";